/** @jsx jsx */
import { Tabs as WrapperTabs, TabsProps } from '@reach/tabs';
import { jsx } from '@front10/base-elements';

export function Tabs(props: TabsProps) {
  return (
    <WrapperTabs
      sx={{
        variant: 'tabs.primary'
      }}
      {...props}
    />
  );
}

export { Tab, TabList, TabPanel, TabPanels } from '@reach/tabs';
